/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Pit1_TInputs */

const en_to_csv_pit1_t = /** @type {(inputs: To_Csv_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty cell means either null or absent, with no way to tell them apart`)
};

const ko_to_csv_pit1_t = /** @type {(inputs: To_Csv_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빈 칸은 null이거나 없음이며, 둘을 구분할 방법이 없습니다`)
};

const ja_to_csv_pit1_t = /** @type {(inputs: To_Csv_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空のセルは null か不在のどちらかで、見分ける方法がありません`)
};

/**
* | output |
* | --- |
* | "Empty cell means either null or absent, with no way to tell them apart" |
*
* @param {To_Csv_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_pit1_t = /** @type {((inputs?: To_Csv_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_pit1_t(inputs)
	if (locale === "ko") return ko_to_csv_pit1_t(inputs)
	return ja_to_csv_pit1_t(inputs)
});